/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';

/**
 * 
 * @export
 * @interface ColumnVisibilitySet
 */
export interface ColumnVisibilitySet {
    /**
     * 
     * @type {number}
     * @memberof ColumnVisibilitySet
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ColumnVisibilitySet
     */
    label?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ColumnVisibilitySet
     */
    shared?: boolean;
    /**
     * 
     * @type {Command}
     * @memberof ColumnVisibilitySet
     */
    deleteCommand?: Command;
    /**
     * 
     * @type {Command}
     * @memberof ColumnVisibilitySet
     */
    saveUpdateCommand?: Command;
    /**
     * 
     * @type {Array<string>}
     * @memberof ColumnVisibilitySet
     */
    visiblePropertyIds: Array<string>;
}

/**
 * Check if a given object implements the ColumnVisibilitySet interface.
 */
export function instanceOfColumnVisibilitySet(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "visiblePropertyIds" in value;

    return isInstance;
}

export function ColumnVisibilitySetFromJSON(json: any): ColumnVisibilitySet {
    return ColumnVisibilitySetFromJSONTyped(json, false);
}

export function ColumnVisibilitySetFromJSONTyped(json: any, ignoreDiscriminator: boolean): ColumnVisibilitySet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'deleteCommand': !exists(json, 'deleteCommand') ? undefined : CommandFromJSON(json['deleteCommand']),
        'saveUpdateCommand': !exists(json, 'saveUpdateCommand') ? undefined : CommandFromJSON(json['saveUpdateCommand']),
        'visiblePropertyIds': json['visiblePropertyIds'],
    };
}

export function ColumnVisibilitySetToJSON(value?: ColumnVisibilitySet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
        'shared': value.shared,
        'deleteCommand': CommandToJSON(value.deleteCommand),
        'saveUpdateCommand': CommandToJSON(value.saveUpdateCommand),
        'visiblePropertyIds': value.visiblePropertyIds,
    };
}

